import { StyleSheet } from 'react-native'

import {
  B1,
  B2,
  B5,
  Icon,
  Input,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { View } from 'moti'

import { ICON_MAP } from '../../../utils/iconMap'

const TextInput = ({
  label,
  placeholder,
  onChange = (value: string | number) => null,
  onBlur,
  value,
  // control,
  errorMessage,
  isRequired,
  isEditable,
  iconLeft,
  iconRight,
  style,
  disabled,
  inputMode,
  keyboardType,
  config,
  noDisabledStyle,
  type,
}) => {
  const HelperIcon = ICON_MAP[config?.helperText?.icon || '']
  return (
    <Stack>
      <B2 className="text-grays-80 mb-1">
        {label}
        {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : <></>}
      </B2>
      <Input
        placeholder={placeholder}
        onBlur={onBlur}
        onChangeText={(value) =>
          onChange(type === 'number' ? Number(value) : value)
        }
        style={[style, disabled && !noDisabledStyle && styles.disabled]}
        value={value}
        showErrorText={errorMessage}
        intent={errorMessage ? 'error' : 'primary'}
        type={errorMessage ? 'error' : 'primary'}
        isEditable={isEditable}
        iconLeft={iconLeft}
        inputMode={inputMode}
        keyboardType={keyboardType}
        iconRight={
          errorMessage ? (
            <View className="relative top-1 mr-1">
              <Icon
                color={zetColors.error[100]}
                type="ErrorOutlined"
                size={28}
              />
            </View>
          ) : (
            iconRight
          )
        }
        noIconPadding={true}
        disabled={disabled}
        maxLength={config?.maxLength || undefined}
      />
      {config?.helperText && (
        <XStack className="mt-3 items-center rounded-[4px] bg-[#EBF3FF] px-2 py-[2px]">
          {HelperIcon && <HelperIcon className="" height={20} width={20} />}
          <B5 className="ml-2 w-[90%] leading-3 text-[#36383F]">
            {config?.helperText?.content}
          </B5>
        </XStack>
      )}
    </Stack>
  )
}

const styles = StyleSheet.create({
  disabled: {
    backgroundColor: zetColors.grays[30],
    fontFamily: 'Graphie-Book',
    margin: 0,
  },
})

export default TextInput
